module.exports = __webpack_public_path__ + "static/media/Ensalada Keto de Camarones con Aderezo.0ed1598f.webp";